import React from 'react';
import { Row, Col } from 'src/componentes/grid';
import Input from '../../componentes/input';
import Checkbox from '../../componentes/checkbox';
import ItemOrganizacaoLookup from '../../lookups/item-organizacao';
import StatusLookup from '../../lookups/status-item';
import PerspectivaLookup from '../../lookups/perspectiva';
import ResponsavelLookup from '../../lookups/colaborador';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { capitalizeFirstLetter } from '../../utils/string';
import TipoItemLookup from 'src/lookups/tipo-item';
import TagLookup from 'src/lookups/TagLookup';
import CatalogoLookup from 'src/lookups/CatalogoNegociacaoMetasLookup';
import { MODULOS, TIPO_ITENS } from 'src/utils/constants';

class ItemSearch extends React.Component {
  render() {
    let { model, resources, intl, parameters, modulosComprados } = this.props;

    const possuiModuloRisco = modulosComprados.find(
      (m) => m.id === MODULOS.GESTAO_RISCO && m.ativo
    );

    const tiposIdSelecionaveis = possuiModuloRisco
      ? parameters?.ehTelaAcao
        ? [1, 2, 3, 4, 5, 6, 7, 17, 19, 21, 20, 23]
        : [1, 2, 3, 4, 5, 6]
      : parameters?.ehTelaAcao
      ? [1, 2, 3, 4, 5, 6, 7]
      : [1, 2, 3, 4, 5, 6];

    const listagemIncluiProjetoAgil =
      parameters?.tiposIdsSelecionados?.includes(TIPO_ITENS.PROJETOS_AGEIS);

    if (
      listagemIncluiProjetoAgil &&
      !tiposIdSelecionaveis.includes(TIPO_ITENS.PROJETOS_AGEIS)
    ) {
      tiposIdSelecionaveis.push(TIPO_ITENS.PROJETOS_AGEIS);
    }

    return (
      <div
        style={{
          width: 700,
          height: 400,
        }}
      >
        <Row>
          <Col md={8}>
            <Input model={model.getModel('nome')} />
          </Col>
          <Col md={4}>
            <Input model={model.getModel('idIntegracao')} />
          </Col>
        </Row>
        {model.getModel('negociacaoMetasCatalogo') &&
        model.getModel('negociacaoMetasCatalogo').value ? (
          <Row>
            <Col md={6}>
              <CatalogoLookup
                disabled
                clearable={false}
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage({ id: 'catalogo' })
                  ),
                  value: model.getModel('negociacaoMetasCatalogo').value,
                  requestChange: model.getModel('negociacaoMetasCatalogo')
                    .requestChange,
                }}
              />
            </Col>
          </Row>
        ) : (
          <Row>
            <Col md={8}>
              <ItemOrganizacaoLookup
                multi={true}
                model={{
                  label: capitalizeFirstLetter(resources.area),
                  value: model.getModel('areas').value,
                  requestChange: model.getModel('areas').requestChange,
                }}
                data={{ tiposIdSelecionaveis: [1, 2, 3] }}
              />
            </Col>
            <Col md={4}>
              <Checkbox
                model={{
                  label: intl.formatMessage(
                    { id: 'label.considerarAreasSubordinadas' },
                    { areas: resources.areas }
                  ),
                  value: model.getModel('areasSubordinadas').value,
                  requestChange:
                    model.getModel('areasSubordinadas').requestChange,
                }}
                style={{ marginTop: 27 }}
              />
            </Col>
          </Row>
        )}
        <Row>
          <Col md={6}>
            <ResponsavelLookup
              multi={true}
              model={{
                label: capitalizeFirstLetter(resources.responsavel),
                value: model.getModel('responsaveis').value,
                requestChange: model.getModel('responsaveis').requestChange,
              }}
            />
          </Col>
          <Col md={6}>
            <StatusLookup
              clearable
              model={model.getModel('status')}
              data={{ idsSelecionados: [1, 2, 3, 4, 5] }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <PerspectivaLookup
              clearable
              menuPlacement="top"
              maxMenuHeight={200}
              model={{
                label: capitalizeFirstLetter(resources.perspectiva),
                value: model.getModel('perspectiva').value,
                requestChange: model.getModel('perspectiva').requestChange,
              }}
            />
          </Col>
          <Col md={6}>
            <TipoItemLookup
              clearable
              menuPlacement="top"
              maxMenuHeight={200}
              model={{
                label: intl.formatMessage({ id: 'label.tipoItem' }),
                value: model.getModel('tipoItem').value,
                requestChange: model.getModel('tipoItem').requestChange,
              }}
              data={
                parameters?.tiposIdsIgnorar
                  ? {
                      tiposIdSelecionaveis,
                      tiposIdsIgnorar: parameters.tiposIdsIgnorar,
                    }
                  : { tiposIdSelecionaveis }
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <TagLookup
              multi
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'tags' }, { tags: resources.tags })
                ),
                value: model.getModel('tags').value,
                requestChange: model.getModel('tags').requestChange,
              }}
              data={{ funcionalidadesIdSelecionaveis: [1, 2, 3] }}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    modulosComprados: state.user.licenca.modulos,
  };
}
export default injectIntl(connect(mapStateToProps)(ItemSearch));
